import { createTheme } from '@mui/material/styles';

const duskTheme = createTheme({
    palette: {
        mode: 'dark',
        background: {
            default: '#2d3236', // Canvas background
            paper: '#2d3236', // Keep uniform
        },
        text: {
            primary: '#ffffff', // CanvasText
            secondary: '#b6f6f0', // Softer, subtle text
        },
        primary: {
            main: '#70ebde', // LinkText
        },
        secondary: {
            main: '#96ff9b', // Visited link color
        },
        success: {
            main: '#96ff9b', // Toast success
        },
        error: {
            main: '#ff6b6b', // Toast error
        },
        warning: {
            main: '#f2c94c', // Toast warning
        },
        info: {
            main: '#70ebde', // Toast info
        },
        action: {
            selected: '#212d3b', // Highlight background
            selectedText: '#a1bfde', // Highlighted text
            hover: 'rgba(112, 235, 222, 0.08)', // Subtle hover effect
        },
        divider: '#444', // Borders, separators
    },

    components: {
        /** Global Scrollbar Styling */
        MuiCssBaseline: {
            styleOverrides: {
                '*': {
                    scrollbarWidth: 'thin',                        // Firefox
                    scrollbarColor: '#4a5568 transparent',         // Firefox: thumb track
                },
                '*::-webkit-scrollbar': {
                    width: 6,
                    height: 6,                                     // horizontal scrollbars too
                },
                '*::-webkit-scrollbar-track': {
                    background: 'transparent',
                },
                '*::-webkit-scrollbar-thumb': {
                    backgroundColor: '#4a5568',                    // visible but unobtrusive against #2d3236
                    borderRadius: 3,
                },
                '*::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: '#70ebde',                    // primary teal on hover
                },
            },
        },

        /** Global Button Styling */
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: '#2d3236',
                    color: '#b6f6f0',
                    border: '1px solid #70ebde',
                    '&:hover': {
                        backgroundColor: '#212d3b',
                    },
                    '&.Mui-disabled': {
                        backgroundColor: '#2d3236',
                        color: 'rgba(182, 246, 240, 0.3)',
                        borderColor: 'rgba(112, 235, 222, 0.2)',
                    },
                },
            },
        },

        /** Toast Styling */
        MuiAlert: {
            styleOverrides: {
                root: ({ ownerState, theme }) => ({
                    mb: 2,
                    borderRadius:
                        theme.shape.borderRadius * 1.5,
                    backgroundColor: (() => {
                        const colors = {
                            success:
                                theme.palette.success.main,
                            error: theme.palette.error.main,
                            warning:
                                theme.palette.warning.main,
                            info: theme.palette.info.main,
                        };
                        return (
                            colors[ownerState.severity] ||
                            theme.palette.info.main
                        );
                    })(),
                    color: theme.palette.getContrastText(
                        theme.palette.background.default
                    ),
                }),
            },
        },
    },

    /** Toast Container Layout */
    toastContainer: {
        position: 'fixed',
        top: 16,
        right: 16,
        display: 'flex',
        flexDirection: 'column',
        zIndex: 9999,
    },
});

export default duskTheme;